import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { IconButton, maxWidth, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section<{
	isBannerVisible: boolean;
}>`
	display: grid;
	position: relative;
	z-index: 0;

	${minWidth('tablet')} {
		grid-template-columns: 50% 50%;
		min-height: calc(
			100vh - ${theme('app.headerHeight')} - ${ifProp('isBannerVisible', theme('app.bannerHeight'), '0px')}
		);
	}

	&:before {
		background: ${palette('bannerText')};
		content: '';
		inset: 0;
		opacity: 0.1;
		position: absolute;
		z-index: -1;
	}
`;
export const Copy = styled.div<{
	centered?: boolean;
}>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	justify-self: center;
	max-width: 560px;
	margin: 40px 20px 0;
	position: relative;

	${minWidth('tablet')} {
		margin: 40px 40px 0;
		${ifProp('centered', 'justify-self: center;', 'justify-self: end;')}
		padding-bottom: 64px;
	}

	${minWidth('desktopLarge')} {
		margin: 40px 80px 0;
	}

	${maxWidth('tablet')} {
		${ifProp('centered', 'align-items: center;')}
	}
`;
export const Heading = styled(Text)`
	&&& {
		font-size: 28px;
		line-height: 1.5;
		margin-bottom: 12px;

		${minWidth('tablet')} {
			font-size: 49.5px;
			margin-bottom: 20px;
		}
	}
`;
export const Body = styled(Text)`
	min-height: 150px;

	&&& {
		margin-bottom: 20px;

		${minWidth('tablet')} {
			margin-bottom: 32px;
			min-height: auto;
		}
	}
`;
export const DownArrow = styled(IconButton)`
	&&& {
		height: 64px;

		${minWidth('tablet')} {
			bottom: 0;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
		}

		& > div {
			height: 20px;
			width: 36px;
		}

		& svg {
			height: 20px;
			width: 36px;
		}
	}
`;
export const ImageContainer = styled.div`
	height: 375px;
	position: relative;

	${minWidth('tablet')} {
		height: auto;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	width: 100%;

	> button:first-child {
		margin-right: 16px;
	}

	${maxWidth('tablet')} {
		padding: 20px;
		flex-direction: column;

		button {
			margin-bottom: 16px;
		}
	}
`;

export const MarqueValueProp = styled(Text)`
	margin-top: 16px;
	font-style: italic;
`;
